import { Action } from "redux";
import { RequestState } from "../../constants/loading";
import { RequestDescription } from "../../types/request-description";
import { Actions } from "../actions";
import { RequestAction } from "../actions/types";

export function defaultRequestDescription(): RequestDescription {
    return {
        correlationId: "unknown",
        route: "unknown",
        started: null,
        ended: null,
        status: RequestState.NOTSTARTED,
    };
}

export interface StatusState {
    events: { [id: string]: RequestDescription };
}

export function statusReducer(state: StatusState, action: Action): StatusState {
    if (!state || action.type === Actions[Actions.LOGOUT]) {
        state = {
            events: {},
        };
    }

    if (action.type === Actions[Actions.EMAIL_FORM_SUBMIT]) {
        const castType = action as RequestAction;
        const description: RequestDescription = {
            correlationId: castType.eventId,
            route: "email-form",
            started: castType.when,
            ended: null,
            status: RequestState.REQUESTED,
        };
        state = {
            ...state,
            events: { ...state.events, [castType.eventId]: description },
        };
    }

    if (action.type === Actions[Actions.EMAIL_FORM_OPERATION_STARTED]) {
        const castType = action as RequestAction;
        const existingDescription: RequestDescription =
            state.events[castType.eventId] || defaultRequestDescription();
        state = {
            ...state,
            events: {
                ...state.events,
                [castType.eventId]: { ...existingDescription, data: castType.data },
            },
        };
    }

    if (action.type === Actions[Actions.EMAIL_FORM_SUCCESS]) {
        const castType = action as RequestAction;
        const existingDescription: RequestDescription =
            state.events[castType.eventId] || defaultRequestDescription();
        const description = {
            ...existingDescription,
            ended: castType.when,
            status: RequestState.DONE,
            data: castType.data,
        };
        state = {
            ...state,
            events: { ...state.events, [castType.eventId]: description },
        };
    }

    if (action.type === Actions[Actions.EMAIL_FORM_ERROR]) {
        const castType = action as RequestAction;
        const existingDescription: RequestDescription =
            state.events[castType.eventId] || defaultRequestDescription();
        const description = {
            ...existingDescription,
            ended: castType.when,
            status: RequestState.ERROR,
            data: castType.data,
        };
        state = {
            ...state,
            events: { ...state.events, [castType.eventId]: description },
        };
    }

    return state;
}
